// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React, { type FC, useEffect, useState } from 'react';
import type { Contentful } from '../../contentful/contentful-exports';
import GenericComponent, {
  type SectionContent,
} from '../GenericComponent/GenericComponent';
import Button, { ButtonVariant } from '../OldButton/OldButton';
import type { SectionType } from '../Section/Section';
import useStyles from './SwitchableContentSelector.style';

/**
 * @deprecated V2 component
 */
export interface SwitchableContentSelectorContent extends Contentful {
  fields: {
    title: string;
    sectionToggleSections: SectionType[];
  };
}

type Props = {
  content: SwitchableContentSelectorContent;
};
const SwitchableContentSelector: FC<Props> = ({ content }) => {
  const { classes } = useStyles();
  const { title, sectionToggleSections } = content.fields;

  const [sectionContentId, setSectionContentId] = useState<string>(
    sectionToggleSections[0].sys.id
  );

  const [currentSwitcheableContent, setCurrentSwitcheableContent] =
    useState<SectionType>(sectionToggleSections[0]);

  useEffect(() => {
    const section = sectionToggleSections.find(
      (sectionContent: SectionType) =>
        sectionContent.sys.id === sectionContentId
    );
    if (section) {
      setCurrentSwitcheableContent(section);
    }
  }, [sectionContentId, sectionToggleSections]);

  return (
    <>
      <div>
        <h1 className={classes.title}>{title}</h1>
      </div>
      <div className={classes.buttonsContainer}>
        {sectionToggleSections.map((section: SectionType) => {
          const isCurrent = section.sys.id === sectionContentId;
          return (
            <Button
              key={section.sys.id}
              onClick={() => setSectionContentId(section.sys.id)}
              label={section.fields.title}
              disabled={isCurrent}
              disableInverseBehavior={isCurrent}
              variant={
                isCurrent
                  ? ButtonVariant.PrimaryBluePill
                  : ButtonVariant.OffWhitePill
              }
            />
          );
        })}
      </div>
      <div>
        {currentSwitcheableContent.fields.content?.map(
          (content: SectionContent) => {
            return <GenericComponent key={content.sys.id} content={content} />;
          }
        )}
      </div>
    </>
  );
};

export default SwitchableContentSelector;
